import React, { useEffect } from "react";
import { useGlobalNotificationBanner } from "Shared/util/custom-hooks";
import useBrandContext from "Contexts/brand-context";
import { BrandName } from "Shared/util/types";

export const useGlobalAlertFraudBanner = () => {
    const { brandData, loadingBrandData } = useBrandContext();
    const {
        NotificationBannerType,
        addGlobalNotificationBanner,
    } = useGlobalNotificationBanner();

    useEffect(() => {
        if (loadingBrandData || brandData?.name === BrandName.FinanceLink) return;

        const BANNER_ID = "FRAUD_BANNER_TEXT_WARNING";

        const phoneNumber = brandData?.name === BrandName.EuroFinans ? "08-420 02 609" : "010 337 09 02";
    
        addGlobalNotificationBanner(
            (tnb) => (
                <>              
                    {tnb.format(
                        tnb.fraud_banner_text_warning,
                        { legalName: brandData?.legalName, phoneNumber },
                    )}
                </>
            ),
            NotificationBannerType.Attention,
            true,
            BANNER_ID,
        );
    }, [loadingBrandData]);
};